'use client';

import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { MethodicCard } from '@eliadmin/core/src/components/shared/methodic-card';
import { buildProductsQuery } from '@eliadmin/core/src/utils/product-utils';
import { fetchProducts } from '@eliadmin/core/src/api/products/product-api';
import type { Category } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

export const ProductsList = ({ category }: { category: Category }) => {
  const locale = useLocaleStore(s => s.currentLocale);
  const me = useCustomerStore(s => s.me);

  const customQueries = buildProductsQuery({
    categories: [category.id],
  });

  const productsQuery = useSuspenseInfiniteQuery({
    queryKey: ['products', category.id, locale, me?.customer.id ?? null],
    queryFn: async ({ pageParam = 1 }) => {
      return await fetchProducts({
        query: {
          ...customQueries,
          page: pageParam,
          results: 6,
        },
        locale,
        authToken: me?.authToken,
      });
    },
    getNextPageParam: (lastPage: any, pages) => {
      if (lastPage?.meta?.current_page < lastPage?.meta?.last_page)
        return lastPage?.meta?.current_page + 1;
      return undefined;
    },
    initialPageParam: 1,
  });

  const products = productsQuery.data?.pages.flatMap((page: any) => page.data) ?? [];

  return (
    <section className={cn('', 'ea-methodics-list__section')}>
      <div className={cn('custom-container', 'ea-methodics-list__container')}>
        {products.map((product, index) => (
          <MethodicCard key={product.slug} methodic={product} index={index} />
        ))}
      </div>
    </section>
  );
};
